import React from "react"

import UserIcon from "../../../../gd-components/icons/user/user"
import {FieldGoalListViewProps} from "../../../render/goal-list/goal-list-view"
import FieldMultiselect from "../../multiselect/multiselect"

type Props = {
    field       : FieldMultiselect
} & FieldGoalListViewProps

const debug = false
// const debug = "FieldAssignees_GoalListView"

export default function FieldAssignees_GoalListView(props: Props) {
    const size = _.get(props.configOptions, 'size', '22')

    const value = _.get(props.model, props.field.fieldId, null)

    const options = props.field._getOptions(value) || []

    debug && console.log(debug, 'render', value, options)

    const optionsNumber: number = options.length
    const maxShow = 3
    if (optionsNumber === 0) {
        debug && console.log(debug, 'render placeholder')
        const showPlaceholder = _.get(props.configOptions, 'showPlaceholder', true)
        return (
            <div className={Classes("ui5-txt-no-accent-default fl-ac max-w-300 ", props.className)} onClick={props.onClick}>
                {showPlaceholder && props.field.placeholder}
            </div>
        )
    } else if (optionsNumber === 1) {
        const userId = options[0].value
        const user = gd.session.users.get(userId)!
        return (
            <div className={Classes("flex-row-left-center", props.className)} onClick={props.onClick}>
                <UserIcon userId={user.id} size={size} className="m-r-5"/>
                <div className="user-name ui5-txt-less-important-small">{user.name}</div>
            </div>
        )
    } else if (optionsNumber <= maxShow) {
        return (
            <div className={Classes("ui5-users-group loose", props.className)} onClick={props.onClick}>
                <div className="flex-row-left-center">
                    {_.map(options.slice(0, maxShow), ((user: Option, key) => (
                        <div key={user.value} className="ico">
                            <UserIcon className="user-icon" size={size} userId={user.value}/>
                        </div>
                    )))}
                </div>
            </div>
        )
    } else {
        const usersToRender = options.slice(0, maxShow - 1)
        const plusMore = "+{0}".f(optionsNumber - (maxShow - 1))
        return (
            <div className={Classes("ui5-users-group loose", props.className)} onClick={props.onClick}>
                <div className="flex-row-left-center">
                    {_.map(usersToRender, ((user: Option, key) => (
                        <div key={user.value} className="ico">
                            <UserIcon className="user-icon" size={size} userId={user.value}/>
                        </div>
                    )))}
                    <div className={Classes("ui5-counter circle-user no-border", 's{0}'.f(size))}>
                        <span className="ui5-txt-not-important-micro">{plusMore}</span>
                    </div>
                </div>

            </div>
        )
    }
}
